import { addToChainAfter, executeAwaitableHandlerChain } from "@insite/client-framework/HandlerCreator";
import {
    Handler,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { CartResult, GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { chain, GetCart } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { RealTimeInventoryModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<
    {
        shouldLoadFullCart?: boolean;
        replaceCart?: boolean;
        getPromotions?: boolean;
        getCartLines?: boolean;
        getCostCodes?: boolean;
    } & HasOnSuccess,
    {
        apiParameter: GetCartApiParameter;
        apiResult: CartResult;
        needFullCart: boolean;
    }
>;

export const LoadInventoryForDiscontinuedProducts: HandlerType = async ({ apiResult, dispatch, getState }) => {

    const products = apiResult.cart.cartLines;

    if (!products?.length) {
        return;
    }

    const productsFiltered = products.filter(o => o.isDiscontinued === true);

    if (!productsFiltered?.length) {
        return;
    }

    const productIds: string[] = [];
    productsFiltered.forEach((o) => {
        if (o.productId !== null && o.productId !== undefined) {
            productIds.push(o.productId)
        }
    });

    const realTimeInventory = await executeAwaitableHandlerChain<
        Parameters<typeof loadRealTimeInventory>[0],
        RealTimeInventoryModel
    >(
        loadRealTimeInventory,
        {
            productIds,
            expand: ["warehouses"]
        },
        { dispatch, getState },
    );


    realTimeInventory.realTimeInventoryResults?.forEach(inventory => {
        products.filter(p => p.productId === inventory.productId)
            .forEach(product => {
                const inventoryAvailability = inventory.inventoryAvailabilityDtos?.find(
                    o => o.unitOfMeasure === product.unitOfMeasure,
                );
                product.availability = inventoryAvailability?.availability || {
                    messageType: 0,
                    message: "",
                    requiresRealTimeInventory: false,
                };
                const inventoryWarehousesDtos = inventory.inventoryWarehousesDtos?.find(
                    o => o.unitOfMeasure === product.unitOfMeasure,
                );
                if (inventoryWarehousesDtos) {
                    let totalStockForShipping = 0;
                    inventoryWarehousesDtos.warehouseDtos?.forEach(wd => {
                        if (product.qtyOrdered && apiResult.cart.defaultWarehouse?.name) {
                            if (apiResult.cart.fulfillmentMethod === FulfillmentMethod.Ship) {
                                totalStockForShipping += wd.qty;
                            }
                        }
                    })
                    inventoryWarehousesDtos.warehouseDtos?.forEach(wd => {
                        if (product.qtyOrdered && apiResult.cart.defaultWarehouse?.name) {
                            // TSCO-233: When Shipping is selected as the fulfillment method, Discontinued Products can be purchased as long as the product is in stock at any warehouse
                            if (apiResult.cart.fulfillmentMethod === FulfillmentMethod.Ship) {
                                product.availability!.message = `${totalStockForShipping} In Stock,Total Stock`;
                                product.availability!.messageType = 1;
                                product.availability!.requiresRealTimeInventory = wd.requiresRealTimeInventory;
                                product.qtyOnHand = totalStockForShipping;
                            }
                            // TSCO-233: When PickUp is selected as the fulfillment method, Discontinued Products can only be purchased if they are in stock at the customer’s selected warehouse
                            if (apiResult.cart.fulfillmentMethod === FulfillmentMethod.PickUp && wd.name === apiResult.cart.defaultWarehouse.name && product.qtyOrdered <= wd.qty) {
                                product.availability!.message = `${wd.qty} In Stock}`;
                                product.availability!.messageType = 1;
                                product.availability!.requiresRealTimeInventory = wd.requiresRealTimeInventory;
                                product.qtyOnHand = wd.qty;
                                product.hasInsufficientInventory = false;
                            }
                            else if (apiResult.cart.fulfillmentMethod === FulfillmentMethod.PickUp && wd.name === apiResult.cart.defaultWarehouse.name && product.qtyOrdered > wd.qty) {
                                product.hasInsufficientInventory = true;
                                product.qtyOnHand = wd.qty;
                                apiResult.cart.canCheckOut = false;
                            }
                        }
                    })
                    if (product.qtyOrdered && apiResult.cart.fulfillmentMethod === FulfillmentMethod.Ship && product.qtyOrdered <= totalStockForShipping) {
                        product.hasInsufficientInventory = false;
                        apiResult.cart.canCheckOut = true;
                    }
                    else if (product.qtyOrdered && apiResult.cart.fulfillmentMethod === FulfillmentMethod.Ship && product.qtyOrdered > totalStockForShipping) {
                        product.hasInsufficientInventory = true;
                        apiResult.cart.canCheckOut = false;
                    }
                }
            });
    });

    let flag = false;
    products.forEach(p => {
        if (p.hasInsufficientInventory) {
            flag = true;
        }
    })
    apiResult.cart.hasInsufficientInventory = flag;
    apiResult.cart.cartLines = products;
};


addToChainAfter(chain, GetCart, LoadInventoryForDiscontinuedProducts);